import { CommonModule } from '@angular/common';
import { Component, ElementRef, Type, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ConfirmationService, FilterService, MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { Table, TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { ProductService } from '../../pages/service/product.service';
import { AstreinteService } from '../../services/astreinte-service/astreinte.service';
import { DividerModule } from 'primeng/divider';
import { MessageModule } from 'primeng/message';
import { CalendarModule } from 'primeng/calendar';
import { Router } from '@angular/router';
import { TabsModule } from 'primeng/tabs';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DatePickerModule } from 'primeng/datepicker';
import { DropdownModule } from 'primeng/dropdown';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-gestion-astreinte',
  imports: [
    BreadcrumbModule,
    CommonModule,
    TableModule,
    FormsModule,
    ButtonModule,
    ToastModule,
    ToolbarModule,
    InputTextModule,
    SelectModule,
    DialogModule,
    InputIconModule,
    IconFieldModule,
    ConfirmDialogModule,
    DividerModule,
    MessageModule,
    CalendarModule,
    TabsModule,
    RadioButtonModule,
    DatePickerModule,
    DropdownModule,
    TextareaModule

  ],
  templateUrl: './gestion-astreinte.component.html',
  styleUrl: './gestion-astreinte.component.scss',
  providers: [MessageService, ProductService, ConfirmationService]
})
export class GestionAstreinteComponent {

  breadcrumbAstreinte = { icon: 'pi pi-home', routerLink: '/rechercher-do' };
  breadcrumbItems = [{ label: 'Gestion Astreinte' }];

  @ViewChild('filter') filter!: ElementRef;
  activeTab: number = 0;
  showSegmentRange: boolean = true;
  segmentationType: number = 1;
  horaireType!: string;
  prioriteValues = 
      Array.from({ length: 30 }, (_, i) => ({
      label: `${i + 1}`,
      value: i + 1
    }));
  prioriteValue: any = null;

  addastreinteDialog: boolean = false;
  detailsastreinteDialog: boolean = false;
  editastreinteDialog: boolean = false;
  submitted: boolean = false;
  astreintes: any;
  astreinte: any = {
    code_Page: null,
    DateHeureDebut: null,
    DateHeureFin: null,
    DateHeureDebutTr2: null,
    DateHeureFinTr2: null,
    TypeHOHNO: null,
    TypeSegment: null,
    Priorite: null,
    Commentaire: null,
    Astreinte: null,
    Escalade1: null,
    Escalade2: null,
    Escalade3: null,
    Escalade4: null,
    Escalade5: null,
    Escalade6: null,
    Escalade7: null,
    Escalade8: null,
    Escalade9: null,
    Escalade10: null,
    Escalade11: null,
    Escalade12: null,
    Escalade13: null,
    Escalade14: null,
    Escalade15: null,
    Critere1: null,
    Critere2: null,
    Critere3: null,
    Critere4: null,
    Critere5: null,
    Critere6: null,
    Critere7: null,
    Critere8: null,
    Critere9: null,
    Critere10: null
  };
  selectedAstreinte: any;
  selectedAstreintes: any[] = [];
  do: any;
  nomDo!: string;
  typesHO: any;
  rowsPerPageOptions: number[] = [10]; // Valeur par défaut
  totalRecords: number = 0;
  loading: boolean = true;

  escaladeLevels: any[] = [];
  maxEscaladeLevels: number = 15;
  selectedEscalades: { [key: number]: { astreinte: any } } = {};
  astreintesList: any = {};
  pagesAstreinteList: any = {};
  selectedAstreintePrincipale: any;
  minDate: Date = new Date();

  isDisable: boolean = false;
  timeRanges: { start: Date | null, end: Date | null }[] = [{ start: null, end: null }];
  dateDebut: Date | null = null;
  dateFin: Date | null = null;

  maxCriteres = 10;
  criteres: any[] = [];
  critereValues: { [key: number]: string } = {}; // Pour stocker les valeurs saisies pour chaque critère

  // Tables disponibles
  tablesList = [
    { nom: 'Societe' },
    { nom: 'Contact' }
  ];

  // Dictionnaire table → colonnes
  colonnesDict: { [key: string]: { nom: string }[] } = {
    Societe: [
      { nom: 'Site' },
      { nom: 'CodePostal' },
      { nom: 'Ville' },
      { nom: 'Departement' },
      { nom: 'Siret' },
      { nom: 'NumContrat' },
      { nom: 'code_Couverture' },
      { nom: 'TypeClient' }
    ],
    Contact: [
      { nom: 'Code_Postal' },
      { nom: 'Ville' },
      { nom: 'Service' },
      { nom: 'Fonction' }

    ]
  };

  // Colonnes affichées selon table choisie
  colonnesList: { nom: string }[] = [];


  constructor(
    private astreinteService: AstreinteService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private filterService: FilterService,
  ) { }
  ngOnInit() {
    const savedSelection = sessionStorage.getItem('selectedDo');
    if (!savedSelection) {
      this.router.navigate(['/rechercher-do']);
    } else {
      let selectedDo = JSON.parse(savedSelection);
      this.do = selectedDo.code_interne;
      this.nomDo = selectedDo.Nom;
    }

    this.loadAstreinteData();
    this.loadListPagesAstreintes();
    this.loadListAstreintes();
    this.loadAstreinteCriteres();
    this.loadAstreinteTypeHo();



    // Enregistrer un filtre global personnalisé
  this.filterService.register('customGlobal', (value :any , filter: any): boolean => {
    if (!filter) {
      return true;
    }
    if (!value) {
      return false;
    }

    const filterText = filter.toLowerCase();

    if (value instanceof Date) {
      // Formater la date au format 'dd/MM/yyyy' en string pour comparaison
      const day = value.getDate().toString().padStart(2, '0');
      const month = (value.getMonth() + 1).toString().padStart(2, '0');
      const year = value.getFullYear();

      const formattedDate = `${day}/${month}/${year}`;

      return formattedDate.includes(filterText);
    }

    // Pour tout autre type, comparer en string (code interne, commentaires, etc.)
    return value.toString().toLowerCase().includes(filterText);
  });


  }


  loadAstreinteCriteres() {
    this.astreinteService.getAstreinteCriteresList(this.do).subscribe({
      next: (data: any) => {
        this.criteres = data.sort((a: any, b: any) => a.Critere - b.Critere);;

        // Initialiser les valeurs des critères
        this.criteres.forEach(critere => {
          this.critereValues[critere.Critere] = '';
        });

      },
      error: (error) => {
        console.error('Erreur lors de la récupération des criteres:', error);
        this.loading = false;
      }
    });
  }

  loadAstreinteTypeHo() {
    this.astreinteService.getAstreinteTypeHoByCodeDo(this.do).subscribe({
      next: (data) => {
       this.typesHO = data;
       // console.log("Type horaires reçu :", this.type_HO);
         // Cocher automatiquement le premier élément (HO) par défaut
      if (this.typesHO && this.typesHO.length > 0) {
        this.horaireType = this.typesHO[0].type_HO;
      }
      },
      error: (error) => {
        console.error('Erreur lors de la récupération du type horaire:', error);
      }
    });
  }
  loadAstreinteData() {
    this.astreinteService.getAllAstreinteByCodeDo(this.do).subscribe({
      next: (data: any) => {
        this.astreintes = data.map((astreinte : any) => ({
          ...astreinte,
          DateHeureDebut: this.convertToDate(astreinte.DateHeureDebut),
          DateHeureFin: this.convertToDate(astreinte.DateHeureFin),
          DateHeureDebutTr2: this.convertToDate(astreinte.DateHeureDebutTr2),
          DateHeureFinTr2: this.convertToDate(astreinte.DateHeureFinTr2),
          DateModif: this.convertToDate(astreinte.DateModif)
        }));

        this.totalRecords = data.length;
        this.updateRowsPerPageOptions();
        //console.log('Astreintes:', this.astreintes);
        this.loading = false;
      },
      error: (error) => {
        console.error('Erreur lors de la récupération des astreintes:', error);
        this.loading = false;
      }
    });
  }
  updateRowsPerPageOptions() {
    const baseOptions = [10, 20, 30, 40, 50];

    // Limitez les options supplémentaires à des valeurs raisonnables
    const maxReasonableOption = 100; // Définissez une limite supérieure raisonnable

    if (this.totalRecords > 50) {
      const additionalOptions = [];
      // Ajoutez des options jusqu'à la limite raisonnable ou au totalRecords (le plus petit des deux)
      const upperLimit = Math.min(this.totalRecords, maxReasonableOption);

      for (let i = 100; i <= upperLimit; i += 100) {
        additionalOptions.push(i);
      }

      this.rowsPerPageOptions = [...baseOptions, ...additionalOptions];
    } else {
      this.rowsPerPageOptions = baseOptions;
    }

    // Ajoutez le totalRecords seulement s'il est raisonnable et différent des options existantes
    if (this.totalRecords <= maxReasonableOption &&
      !this.rowsPerPageOptions.includes(this.totalRecords)) {
      this.rowsPerPageOptions.push(this.totalRecords);
    }
  }


  clear(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  // Charger la liste des pages disponibles
  loadListPagesAstreintes() {
    this.astreinteService.getAstreinteListPages(this.do).subscribe({
      next: (data: any) => {
        this.pagesAstreinteList = data;
        //console.log('Liste des pages:', this.pagesAstreinteList);
      },
      error: (error) => {
        console.error('Error fetching pages list:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Impossible de charger la liste des pages',
          life: 3000
        });
      }
    });
  }

  // Charger la liste des astreintes disponibles
  loadListAstreintes() {
    this.astreinteService.getAstreintesList(this.do).subscribe({
      next: (data: any) => {
        this.astreintesList = data;
        //console.log('Liste des astreintes:', this.astreintesList);
      },
      error: (error) => {
        console.error('Error fetching astreintes list:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Impossible de charger la liste des astreintes',
          life: 3000
        });
      }
    });
  }


  openNewAstreinte() {
    this.submitted = false;
    this.addastreinteDialog = true;

    // Réinitialiser les sélections
    this.selectedAstreintePrincipale = null;
    this.selectedEscalades = {}; // Objet vide au lieu d'avoir le niveau 1

    this.astreinte = {};

    this.segmentationType = 1;
    this.showSegmentRange = true;
    this.horaireType = this.typesHO[0].type_HO;
    this.dateDebut = null;
    this.dateFin = null;
    this.timeRanges = [{ start: null, end: null }]; 
    this.prioriteValue = 1;
    this.critereValues = {};

    // Charger la liste des pages disponibles
    // this.astreinteService.getAstreinteListPages(this.do).subscribe({
    //     next: (data: any) => {
    //         this.pagesAstreinteList = data;
    //         //console.log('Liste des pages:', this.pagesAstreinteList);
    //     }
    // });

    // Charger la liste des astreintes disponibles
    //     this.astreinteService.getAstreintesList(this.do).subscribe({
    //     next: (data: any) => {
    //         this.astreintesList = data;
    //         //console.log('Liste des astreintes:', this.astreintesList);
    //     },
    //     error: (error) => {
    //         console.error('Error fetching astreintes list:', error);
    //         this.messageService.add({
    //             severity: 'error',
    //             summary: 'Erreur',
    //             detail: 'Impossible de charger la liste des astreintes',
    //             life: 3000
    //         });
    //     }
    // });
  }
  hideAddDialog() {
    this.addastreinteDialog = false;
    //this.submitted = false;
  }
  hideDetailsDialog() {
    this.detailsastreinteDialog = false;
    this.submitted = false;
  }

  deleteByAstreinte(astreinte: any) {

    this.confirmationService.confirm({
      message: 'Souhaitez-vous vraiment supprimer ' + astreinte.Astreinte_Nom + '?',
      header: 'Confirmer',
      icon: 'pi pi-exclamation-triangle',
      rejectButtonStyleClass: 'p-button-secondary',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.astreinteService.deleteAstreinte([astreinte.code_interne]).subscribe(
          (result: any) => {
            console.warn(result);
            this.loadAstreinteData();

            this.messageService.add({
              severity: 'success',
              summary: 'Succès',
              detail: 'Astreinte supprimé avec succès',
              life: 3000,

            });
          },
          (error) => {
            console.log(error);
            this.messageService.add({
              severity: 'error',
              summary: 'Erreur',
              detail: 'Échec de la suppression de l\'astreinte' + astreinte.Astreinte_Nom,
              life: 3000
            });
          }
        )

      }
    });
  }

  deleteSelectedAstreintes() {
    this.confirmationService.confirm({
      message: 'Souhaitez-vous vraiment supprimer les astreintes ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      rejectButtonStyleClass: 'p-button-secondary',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        console.log('Bouton cliqué - selected:', this.selectedAstreintes);
        if (!this.selectedAstreintes || this.selectedAstreintes.length === 0) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Avertissement',
            detail: 'Aucune astreinte sélectionnée',
            life: 3000
          });
          return;
        }

        const codes = this.selectedAstreintes.map(a => a.code_interne);
        this.astreinteService.deleteAstreinte(codes).subscribe({
          next: () => {
            // 1. Rafraîchir les données depuis le serveur
            this.loadAstreinteData();

            // 2. Vider la sélection
            this.selectedAstreintes = [];

            // 3. Afficher le message de succès
            this.messageService.add({
              severity: 'success',
              summary: 'Succès',
              detail: `${codes.length} astreinte(s) supprimée(s)`,
              life: 3000
            });
          },
          error: (error) => {
            console.error('Erreur lors de la suppression:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Erreur',
              detail: 'Une erreur est survenue lors de la suppression',
              life: 3000
            });
          }
        });
      }
    });
  }

  openDetailsAstreinte(astreinteItem: any) {
    this.selectedAstreinte = astreinteItem;
    // Initialiser critereValues avec les valeurs de l'astreinte sélectionnée
    this.critereValues = {};
    this.criteres.forEach(critere => {
      const critereKey = `Critere${critere.Critere}`;
      this.critereValues[critere.Critere] = astreinteItem[critereKey] || '';
    });
    this.detailsastreinteDialog = true;
  }

  //méthode pour gérer l'ajout d'escalade
  addEscaladeLevel(currentLevel: number) {
    const nextLevel = currentLevel === 0 ? 1 : currentLevel + 1;

    if (nextLevel <= this.maxEscaladeLevels) {
      if (!this.selectedEscalades[nextLevel]) {
        this.selectedEscalades[nextLevel] = {
          astreinte: null
        };
      }
    }
  }

  // Méthode pour supprimer un niveau d'escalade
  removeEscaladeLevel(level: number) {
    // 1. Supprimer le niveau spécifié
    delete this.selectedEscalades[level];

    // 2. Réorganiser les niveaux restants pour qu'ils soient séquentiels
    const remainingLevels = this.getEscaladeLevels();
    const newSelectedEscalades: { [key: number]: any } = {};

    remainingLevels.forEach((oldLevel, index) => {
      const newLevel = index + 1;
      newSelectedEscalades[newLevel] = this.selectedEscalades[oldLevel];
    });

    this.selectedEscalades = newSelectedEscalades;
  }

  getEscaladeLevels(): number[] {
    return Object.keys(this.selectedEscalades)
      .map(level => +level)
      .sort((a, b) => a - b);
  }

  validateAndSave() {
    this.submitted = true;

    // Validation spécifique selon le type de segmentation
    if (this.showSegmentRange) {
      // Validation pour la période continue
      if (!this.astreinte.DateHeureDebut || !this.astreinte.DateHeureFin) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Les dates/heures de début et fin sont obligatoires',
          life: 3000
        });
        return;
      }

      // Validation des dates obligatoires
      if (!this.astreinte.DateHeureDebut || !this.astreinte.DateHeureFin) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Veuillez renseigner les dates de début et de fin',
          life: 3000
        });
        this.isDisable = false;
        return;
      }
      const now = new Date();
      now.setSeconds(0, 0);

      // if (new Date(astreinte.DateHeureDebut) <= now) {
      //     this.messageService.add({
      //         severity: 'error',
      //         summary: 'Erreur',
      //         detail: 'La date de début doit être supérieure à la date/heure actuelle',
      //         life: 3000
      //     });
      //     return;
      // }
      //console.log("Heure de fin invalide:", astreinte.DateHeureFin, "doit être supérieure à l'heure de début:", astreinte.DateHeureDebut);

      // Validation: Date de fin doit être supérieure à la date de début
      const debut = new Date(this.astreinte.DateHeureDebut);
      const fin = new Date(this.astreinte.DateHeureFin);

      // Comparaison jusqu'à la minute
      if (fin.getFullYear() <= debut.getFullYear() &&
        fin.getMonth() <= debut.getMonth() &&
        fin.getDate() <= debut.getDate() &&
        fin.getHours() <= debut.getHours() &&
        fin.getMinutes() <= debut.getMinutes()) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'L\'heure de fin doit être supérieure à l\'heure de début',
          life: 3000
        });
        this.isDisable = false;
        return;
      }
    } else {
      // Validation pour la période non continue
      if (!this.validateTimeRanges()) {
        return;
      }
    }

    // Préparer le payload pour la validation
    const payloadValidation = this.preparePayloadForValidation();

    // Vérifier les doublons de dates/heures avec même priorité
     const duplicateAstreinte = this.checkDuplicateDateTime(payloadValidation);
  if (duplicateAstreinte) {
    this.messageService.add({
      severity: 'error',
      summary: 'Erreur',
      detail: `Chevauchement détecté avec le planning de code ${duplicateAstreinte.code_interne} pour les mêmes dates/heures et même critère`,
      life: 3000
    });
    return;
  }

      // Vérifier les chevauchements pour le MÊME type de segmentation
      const overlapResult = this.checkPlanningOverlaps(payloadValidation);
      if (overlapResult.hasOverlap) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: `Chevauchement détecté avec le planning de code ${overlapResult.conflictingCode} pour la même type de segmentation`,
          life: 3000
        });
        return;
      }

    // Validation commune
    if (!this.selectedAstreintePrincipale) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Veuillez sélectionner une astreinte principale',
        life: 3000
      });
      return;
    }

    this.isDisable = true;
    this.addAstreinte(this.astreinte);
  }

// Modifier preparePayloadForValidation pour inclure les critères
private preparePayloadForValidation(): any {
  const payload: any = {
    DateHeureDebut: null,
    DateHeureFin: null,
    DateHeureDebutTr2: null,
    DateHeureFinTr2: null,
    Priorite: this.prioriteValue,
    TypeSegment: this.segmentationType,
    TypeHOHNO: this.horaireType
  };

  if (this.showSegmentRange) {
    payload.DateHeureDebut = this.astreinte.DateHeureDebut;
    payload.DateHeureFin = this.astreinte.DateHeureFin;
  } else {
    // Pour période non continue
    const firstRange = this.timeRanges[0];
    if (this.dateDebut && this.dateFin && firstRange.start && firstRange.end) {
      payload.DateHeureDebut = this.concatDateTime(this.dateDebut, firstRange.start);
      payload.DateHeureFin = this.concatDateTime(this.dateFin, firstRange.end);
    }

    if (this.timeRanges.length > 1 && this.timeRanges[1].start && this.timeRanges[1].end && this.dateDebut && this.dateFin) {
      payload.DateHeureDebutTr2 = this.concatDateTime(this.dateDebut, this.timeRanges[1].start);
      payload.DateHeureFinTr2 = this.concatDateTime(this.dateFin, this.timeRanges[1].end);
    }
  }

  // Inclure les critères dans le payload de validation
  for (let i = 1; i <= 10; i++) {
    payload[`Critere${i}`] = this.critereValues[i] || null;
  }

  return payload;
}


  isFormAddValid(): boolean {
    // Vérification des champs obligatoires
    if (!this.selectedAstreintePrincipale ||
      !this.selectedAstreintePrincipale.code_interne ||
      !this.astreinte.DateHeureFin) {
      this.isDisable = false;
      return false;
    }

    // Vérification des dates
    const now = new Date();
    const debut = new Date(this.astreinte.DateHeureDebut);
    const fin = new Date(this.astreinte.DateHeureFin);

    this.isDisable = false;
    return fin > debut;
  }

  addAstreinte(astreinte: any) {

    // Préparer le payload pour l'API
    astreinte = {
      code_DO: this.do,
      code_Page: this.astreinte.code_Page?.code_interne || null,
      Astreinte: this.selectedAstreintePrincipale.code_interne,
      // Initialiser toutes les escalades à null
      TypeHOHNO: this.horaireType,
      TypeSegment: this.segmentationType,
      Priorite: this.prioriteValue,
      Commentaire: this.astreinte.Commentaire,
      DateHeureDebut: null,
      DateHeureFin: null,
      DateHeureDebutTr2: null,
      DateHeureFinTr2: null,
      Critere1: null,
      Critere2: null,
      Critere3: null,
      Critere4: null,
      Critere5: null,
      Critere6: null,
      Critere7: null,
      Critere8: null,
      Critere9: null,
      Critere10: null,
      Escalade1: null,
      Escalade2: null,
      Escalade3: null,
      Escalade4: null,
      Escalade5: null,
      Escalade6: null,
      Escalade7: null,
      Escalade8: null,
      Escalade9: null,
      Escalade10: null,
      Escalade11: null,
      Escalade12: null,
      Escalade13: null,
      Escalade14: null,
      Escalade15: null
    };


    // Gestion selon le type de segmentation
    if (this.showSegmentRange) {
      // Période continue
      astreinte.DateHeureDebut = this.formatDateForApi(this.astreinte.DateHeureDebut);
      astreinte.DateHeureFin = this.formatDateForApi(this.astreinte.DateHeureFin);
    } else {
      // Période non continue
      // tranche 1 obligatoire
      const firstRange = this.timeRanges[0];
      if (this.dateDebut && this.dateFin && firstRange.start && firstRange.end) {
        astreinte.DateHeureDebut = this.formatDateForApi(this.concatDateTime(this.dateDebut, firstRange.start));
        astreinte.DateHeureFin = this.formatDateForApi(this.concatDateTime(this.dateFin, firstRange.end));
      }

      // Si une deuxième tranche est remplie
      if (this.timeRanges.length > 1 && this.timeRanges[1].start && this.timeRanges[1].end && this.dateDebut && this.dateFin) {
        astreinte.DateHeureDebutTr2 = this.formatDateForApi(this.concatDateTime(this.dateDebut, this.timeRanges[1].start));
        astreinte.DateHeureFinTr2 = this.formatDateForApi(this.concatDateTime(this.dateFin, this.timeRanges[1].end));
      }
    }

    // Remplir les valeurs des critéres existantes
    this.criteres.forEach(critere => {
      const critereKey = `Critere${critere.Critere}`;
      astreinte[critereKey] = this.critereValues[critere.Critere] || null;
      console.log(`Critère ${critereKey} ajouté avec la valeur:`, astreinte[critereKey]);
    });

    // Remplir les escalades existantes
    this.getEscaladeLevels().forEach(level => {
      const escalade = this.selectedEscalades[level];
      if (escalade.astreinte) {
        astreinte[`Escalade${level}`] = escalade.astreinte.code_interne; // code_interne de l'astreinte sélectionnée
      }
    });
    console.log('Payload add Astreinte envoyé:', astreinte);

    // Envoyer les données au service
    this.astreinteService.addAstreinte(astreinte).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: 'Astreinte enregistrée avec succès',
          life: 3000
        });
        this.isDisable = false;
        this.hideAddDialog();
        this.loadAstreinteData();
      },
      error: (error) => {
        console.error('Erreur:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Échec de l\'enregistrement de l\'astreinte',
          life: 3000
        });
      }
    });
  }

  // Ajoutez cette méthode utilitaire pour formater les dates
  private formatDateForApi(date: Date): string {
    if (!date) return '';

    // Formatage manuel sans T et Z
    const pad = (num: number) => num.toString().padStart(2, '0');

    return date.getFullYear() + '-' +
      pad(date.getMonth() + 1) + '-' +
      pad(date.getDate()) + ' ' +
      pad(date.getHours()) + ':' +
      pad(date.getMinutes()) + ':' +
      pad(date.getSeconds());
  }

  // Validation pour les tranches horaires
  validateTimeRanges(): boolean {
    // Validation des dates obligatoires pour la segmentation non continue
    if (!this.showSegmentRange) {
      if (!this.dateDebut || !this.dateFin) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Les dates de début et fin sont obligatoires',
          life: 3000
        });
        return false;
      }
    }

    // Validation des tranches horaires
    for (let i = 0; i < this.timeRanges.length; i++) {
      const range = this.timeRanges[i];

      // Tranche 1 est obligatoire
      if (i === 0 && (!range.start || !range.end)) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'La première tranche horaire est obligatoire',
          life: 3000
        });
        return false;
      }

      // Pour les tranches suivantes, soit les deux champs sont remplis, soit aucun
      if (i > 0 && ((range.start && !range.end) || (!range.start && range.end))) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Pour les tranches supplémentaires, veuillez remplir les deux heures ou aucun',
          life: 3000
        });
        return false;
      }

      // Vérifier que l'heure de fin est après l'heure de début pour chaque tranche remplie
      // if (range.start && range.end && range.end <= range.start) {
      //   this.messageService.add({
      //     severity: 'error',
      //     summary: 'Erreur',
      //     detail: `L'heure de fin doit être supérieure à l'heure de début pour la tranche ${i + 1}`,
      //     life: 3000
      //   });
      //   return false;
      // }
    }

    return true;
  }

  // Méthode pour concaténer date et heure pour le payload
  concatDateTime(date: Date, time: Date): Date {
    if (!date || !time) return new Date();

    const newDate = new Date(date);
    newDate.setHours(time.getHours());
    newDate.setMinutes(time.getMinutes());
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);

    return newDate;
  }

// Modifier checkPlanningOverlaps pour prendre en compte les critères
checkPlanningOverlaps(newAstreinte: any): { hasOverlap: boolean, conflictingCode: string } {
  if (!this.astreintes || this.astreintes.length === 0) {
    return { hasOverlap: false, conflictingCode: '' };
  }

  const newDebut = new Date(newAstreinte.DateHeureDebut);
  const newFin = new Date(newAstreinte.DateHeureFin);
  const newDebutTr2 = newAstreinte.DateHeureDebutTr2 ? new Date(newAstreinte.DateHeureDebutTr2) : null;
  const newFinTr2 = newAstreinte.DateHeureFinTr2 ? new Date(newAstreinte.DateHeureFinTr2) : null;
  const newPriorite = newAstreinte.Priorite;
  const newTypeHoraire = newAstreinte.TypeHOHNO;

  for (const existingAstreinte of this.astreintes) {
    // Vérifier si même priorité
    if (existingAstreinte.Priorite === newPriorite) {
      const existDebut = new Date(existingAstreinte.DateHeureDebut);
      const existFin = new Date(existingAstreinte.DateHeureFin);
      const existDebutTr2 = existingAstreinte.DateHeureDebutTr2 ? new Date(existingAstreinte.DateHeureDebutTr2) : null;
      const existFinTr2 = existingAstreinte.DateHeureFinTr2 ? new Date(existingAstreinte.DateHeureFinTr2) : null;
      const existTypeHoraire = existingAstreinte.TypeHOHNO;

      // Vérifier si les types horaires sont les mêmes
      const typesHoraireIdentiques = newTypeHoraire === existTypeHoraire;

      // Pour les périodes non continues (TypeSegment = 0), on vérifie les chevauchements d'heures
      if (newAstreinte.TypeSegment === 0 && existingAstreinte.TypeSegment === 0) {
        // Même date mais heures différentes → autorisé
        const sameDate = this.isSameDate(newDebut, existDebut) && this.isSameDate(newFin, existFin);
        
        if (sameDate) {
          // Vérifier si les heures se chevauchent
          if (this.isTimeOverlapping(newDebut, newFin, existDebut, existFin)) {
            // Vérifier s'il y a chevauchement des critères
            if (typesHoraireIdentiques && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
              return { hasOverlap: true, conflictingCode: existingAstreinte.code_interne || existingAstreinte.Astreinte };
            }
          }
          
          // Vérifier les tranches 2 si elles existent
          if (newDebutTr2 && newFinTr2 && existDebutTr2 && existFinTr2 &&
              this.isTimeOverlapping(newDebutTr2, newFinTr2, existDebutTr2, existFinTr2)) {
            // Vérifier s'il y a chevauchement des critères
            if (typesHoraireIdentiques && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
              return { hasOverlap: true, conflictingCode: existingAstreinte.code_interne || existingAstreinte.Astreinte };
            }
          }
        }
      } else {
        // Pour les périodes continues ou mixtes, vérifier normalement
        // Vérifier chevauchement tranche 1
        if (this.isOverlapping(newDebut, newFin, existDebut, existFin)) {
          // Si chevauchement ET types horaires identiques ET chevauchement de critères → détecter le conflit
          if (typesHoraireIdentiques && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
            return { hasOverlap: true, conflictingCode: existingAstreinte.code_interne || existingAstreinte.Astreinte };
          }
        }

        // Vérifier chevauchement tranche 2 si elle existe
        if (newDebutTr2 && newFinTr2 && existDebutTr2 && existFinTr2 &&
          this.isOverlapping(newDebutTr2, newFinTr2, existDebutTr2, existFinTr2)) {
          // Si chevauchement ET types horaires identiques ET chevauchement de critères → détecter le conflit
          if (typesHoraireIdentiques && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
            return { hasOverlap: true, conflictingCode: existingAstreinte.code_interne || existingAstreinte.Astreinte };
          }
        }

        // Vérifier chevauchements croisés entre tranches
        if (newDebutTr2 && newFinTr2 && this.isOverlapping(newDebutTr2, newFinTr2, existDebut, existFin)) {
          // Si chevauchement ET types horaires identiques ET chevauchement de critères → détecter le conflit
          if (typesHoraireIdentiques && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
            return { hasOverlap: true, conflictingCode: existingAstreinte.code_interne || existingAstreinte.Astreinte };
          }
        }

        if (existDebutTr2 && existFinTr2 && this.isOverlapping(newDebut, newFin, existDebutTr2, existFinTr2)) {
          // Si chevauchement ET types horaires identiques ET chevauchement de critères → détecter le conflit
          if (typesHoraireIdentiques && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
            return { hasOverlap: true, conflictingCode: existingAstreinte.code_interne || existingAstreinte.Astreinte };
          }
        }
      }
    }
  }

  return { hasOverlap: false, conflictingCode: '' };
}

// Méthode pour vérifier si deux dates sont les mêmes (sans l'heure)
isSameDate(date1: Date, date2: Date): boolean {
  if (!date1 || !date2) return false;
  
  return date1.getFullYear() === date2.getFullYear() &&
         date1.getMonth() === date2.getMonth() &&
         date1.getDate() === date2.getDate();
}

// Méthode pour vérifier le chevauchement des heures (sur la même date)
isTimeOverlapping(start1: Date, end1: Date, start2: Date, end2: Date): boolean {
  if (!this.isSameDate(start1, start2)) return false;
  
  const time1Start = start1.getHours() * 60 + start1.getMinutes();
  const time1End = end1.getHours() * 60 + end1.getMinutes();
  const time2Start = start2.getHours() * 60 + start2.getMinutes();
  const time2End = end2.getHours() * 60 + end2.getMinutes();
  
  return time1Start < time2End && time1End > time2Start;
}

// Méthode pour vérifier les doublons de dates/heures avec même priorité ET mêmes critères
checkDuplicateDateTime(newAstreinte: any): any | null {
  if (!this.astreintes || this.astreintes.length === 0) return null;

  const newDebut = new Date(newAstreinte.DateHeureDebut);
  const newFin = new Date(newAstreinte.DateHeureFin);
  const newPriorite = newAstreinte.Priorite;

 for (const existingAstreinte of this.astreintes) {
    if (existingAstreinte.Priorite === newPriorite) {
      const existDebut = new Date(existingAstreinte.DateHeureDebut);
      const existFin = new Date(existingAstreinte.DateHeureFin);

      const sameDateTime = (newDebut.getTime() === existDebut.getTime() && newFin.getTime() === existFin.getTime());

      if (sameDateTime && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
        return existingAstreinte; // Retourne l'astreinte conflictuelle
      }
    }
  }
  return null;
}
// Méthode pour vérifier si les critères sont identiques
areCriteresIdentiques(astreinteA: any, astreinteB: any): boolean {
  for (let i = 1; i <= 10; i++) {
    const critereA = astreinteA[`Critere${i}`];
    const critereB = astreinteB[`Critere${i}`];

    // Normaliser les valeurs (trim, lowercase)
    const normalizedA = critereA ? String(critereA).trim().toLowerCase() : null;
    const normalizedB = critereB ? String(critereB).trim().toLowerCase() : null;

    // Si les deux sont null ou vides, on continue
    if ((!normalizedA || normalizedA === 'null') && (!normalizedB || normalizedB === 'null')) {
      continue;
    }

    // Si un seul a une valeur et l'autre est null/vide, alors les critères sont différents
    if ((normalizedA && normalizedA !== 'null' && (!normalizedB || normalizedB === 'null')) ||
        (normalizedB && normalizedB !== 'null' && (!normalizedA || normalizedA === 'null'))) {
      return false;
    }

    // Si les deux ont des valeurs non nulles, vérifier s'il y a chevauchement
    if (normalizedA && normalizedA !== 'null' && normalizedB && normalizedB !== 'null') {
      if (!this.hasOverlappingCritereValues(normalizedA, normalizedB)) {
        return false; // Pas de chevauchement → critères différents
      }
    }
  }
  
  // Tous les critères se chevauchent ou sont compatibles
  return true;
}

// Méthode pour vérifier le chevauchement des valeurs de critères
hasOverlappingCritereValues(valueA: string, valueB: string): boolean {
  // Tokeniser les deux valeurs
  const tokensA = this.tokenizeCritereValue(valueA);
  const tokensB = this.tokenizeCritereValue(valueB);

  // Si au moins un token est commun, il y a chevauchement
  return tokensA.some(tokenA => tokensB.includes(tokenA)) ||
         tokensB.some(tokenB => tokensA.includes(tokenB));
}

// Méthode pour tokeniser une valeur de critère (inchangée)
tokenizeCritereValue(rawValue: string): string[] {
  return String(rawValue)
    .split(/[,;]+/)
    .map(t => t.trim())
    .filter(t => t !== '')
    .map(t => t.toLowerCase());
}

  // Méthode utilitaire pour vérifier le chevauchement de deux périodes
  isOverlapping(start1: Date, end1: Date, start2: Date, end2: Date): boolean {
    return start1 < end2 && end1 > start2;
  }

  openEditAstreinte(astreinteItem: any) {
    this.submitted = false;

    // Déterminer le type de segment et ouvrir le bon dialog
    // if (astreinteItem.TypeSegment == 1) {
    //   this.updateAstreinteContinueDialog = true;
    // } else {
    //   this.updateAstreinteNonContinueDialog = true;
    // }
    this.editastreinteDialog = true;
    // Réinitialiser toutes les données de formulaire
    this.selectedAstreintePrincipale = null;
    this.selectedEscalades = {};
    this.timeRanges = [];
    this.astreinte = {};
    this.prioriteValue = astreinteItem.Priorite;

    // Initialiser showSegmentRange basé sur TypeSegment
    this.showSegmentRange = astreinteItem.TypeSegment == 1;
    this.segmentationType = astreinteItem.TypeSegment;

    // Intialisation des valeurs de dates
    this.dateDebut = astreinteItem.DateHeureDebut ? new Date(astreinteItem.DateHeureDebut) : null;
    this.dateFin = astreinteItem.DateHeureFin ? new Date(astreinteItem.DateHeureFin) : null;

    // Initialiser les valeurs des critères pour l'édition
    this.criteres.forEach(critere => {
        const critereKey = `Critere${critere.Critere}`;
        this.critereValues[critere.Critere] = astreinteItem[critereKey] || '';
    });

    // Retrouver la page
    const pageObj = this.pagesAstreinteList.find((p: any) =>
      p.code_interne === astreinteItem.code_Page || p.Nom_Page === astreinteItem.code_Page
    );

    // Préparer l'objet astreinte principal
    this.astreinte = {
      ...astreinteItem,
      code_Page: pageObj || null,
      DateHeureDebut: astreinteItem.DateHeureDebut ? new Date(astreinteItem.DateHeureDebut) : null,
      DateHeureFin: astreinteItem.DateHeureFin ? new Date(astreinteItem.DateHeureFin) : null,
      segmentationType: astreinteItem.TypeSegment,
      TypeHOHNO: astreinteItem.TypeHOHNO
    };


     // 🔹 Initialiser les tranches horaires pour TypeSegment = 2
  if (astreinteItem.TypeSegment != 1) {
    this.timeRanges = [];

    // Tranche 1
    if (astreinteItem.DateHeureDebut && astreinteItem.DateHeureFin) {
      this.timeRanges.push({
        start: new Date(astreinteItem.DateHeureDebut),
        end: new Date(astreinteItem.DateHeureFin)
      });
    } else {
      this.timeRanges.push({ start: null, end: null });
    }

    // Tranche 2 si elle existe
    if (astreinteItem.DateHeureDebutTr2 && astreinteItem.DateHeureFinTr2) {
      this.timeRanges.push({
        start: new Date(astreinteItem.DateHeureDebutTr2),
        end: new Date(astreinteItem.DateHeureFinTr2)
      });
    } else {
      // AJOUT: Ajouter une tranche vide si nécessaire
      this.timeRanges.push({ start: null, end: null });
    }
  } else {
    // Pour TypeSegment = 1
    this.timeRanges = [{ start: null, end: null }];
  }

    // Sélectionner l'astreinte principale
    this.selectedAstreintePrincipale = this.astreintesList.find(
      (a: any) =>
        a.code_interne === astreinteItem.Astreinte?.code_interne ||
        a.Astreinte_Nom === astreinteItem.Astreinte_Nom
    ) || null;

    // Préparer les escalades
    for (let i = 1; i <= 15; i++) {
      const code = astreinteItem[`Escalade${i}`];
      const nom = astreinteItem[`Escalade${i}_Nom`];
      if (code || nom) {
        const ast = this.astreintesList.find(
          (a: any) => a.code_interne === code || a.Astreinte_Nom === nom
        );
        if (ast) {
          this.selectedEscalades[i] = { astreinte: ast };
        }
      }
    }
  }


  // Ajoutez cette méthode pour fermer le dialog d'édition
  hideEditDialog() {
    this.editastreinteDialog = false;
    this.submitted = false;
  }
  isFormEditValid(): boolean {
    // Vérification des champs obligatoires
    if (!this.selectedAstreintePrincipale ||
      !this.selectedAstreintePrincipale.code_interne ||
      !this.astreinte.DateHeureDebut ||
      !this.astreinte.DateHeureFin) {
      this.isDisable = false;
      return false;
    }

    // Vérification des dates
    const debut = new Date(this.astreinte.DateHeureDebut);
    const fin = new Date(this.astreinte.DateHeureFin);

    this.isDisable = false;
    return fin > debut;
  }
  // Ajoutez cette méthode pour valider et mettre à jour
  validateAndUpdate() {
    this.submitted = true;

    // Validation spécifique selon le type de segmentation
    if (this.showSegmentRange) {
      // Validation pour la période continue
      if (!this.astreinte.DateHeureDebut || !this.astreinte.DateHeureFin) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Les dates/heures de début et fin sont obligatoires',
          life: 3000
        });
        return;
      }

      // Validation des dates obligatoires
      if (!this.astreinte.DateHeureDebut || !this.astreinte.DateHeureFin) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Veuillez renseigner les dates de début et de fin',
          life: 3000
        });
        this.isDisable = false;
        return;
      }
      const now = new Date();
      now.setSeconds(0, 0);

      // if (new Date(astreinte.DateHeureDebut) <= now) {
      //     this.messageService.add({
      //         severity: 'error',
      //         summary: 'Erreur',
      //         detail: 'La date de début doit être supérieure à la date/heure actuelle',
      //         life: 3000
      //     });
      //     return;
      // }
      //console.log("Heure de fin invalide:", astreinte.DateHeureFin, "doit être supérieure à l'heure de début:", astreinte.DateHeureDebut);

      // Validation: Date de fin doit être supérieure à la date de début
      const debut = new Date(this.astreinte.DateHeureDebut);
      const fin = new Date(this.astreinte.DateHeureFin);

      // Comparaison jusqu'à la minute
      if (fin.getFullYear() <= debut.getFullYear() &&
        fin.getMonth() <= debut.getMonth() &&
        fin.getDate() <= debut.getDate() &&
        fin.getHours() <= debut.getHours() &&
        fin.getMinutes() <= debut.getMinutes()) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'L\'heure de fin doit être supérieure à l\'heure de début',
          life: 3000
        });
        this.isDisable = false;
        return;
      }
    } else {
      // Validation pour la période non continue
      if (!this.validateTimeRanges()) {
        return;
      }
    }

     // Préparer le payload pour la validation
    const payloadValidation = this.preparePayloadForValidation();


    // Vérifier les doublons en excluant l'astreinte actuelle
    const duplicateAstreinte = this.checkDuplicateDateTimeForUpdate(payloadValidation, this.astreinte.code_interne);
  if (duplicateAstreinte) {
    this.messageService.add({
      severity: 'error',
      summary: 'Erreur',
      detail: `Chevauchement détecté avec le planning de code ${duplicateAstreinte.code_interne} pour les mêmes dates/heures et même critère`,
      life: 3000
    });
    return;
  }

     // Vérifier les chevauchements en excluant l'astreinte actuelle
    const overlapResult = this.checkPlanningOverlapsForUpdate(payloadValidation, this.astreinte.code_interne);
  if (overlapResult.hasOverlap) {
    this.messageService.add({
      severity: 'error',
      summary: 'Erreur',
      detail: `Chevauchement détecté avec le planning de code ${overlapResult.conflictingCode} pour le même type de segmentation`,
      life: 3000
    });
    return;
  }

    // Validation commune
    if (!this.selectedAstreintePrincipale) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Veuillez sélectionner une astreinte principale',
        life: 3000
      });
      return;
    }

    if (!this.prioriteValue) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'La priorité est obligatoire',
        life: 3000
      });
      return;
    }

    this.isDisable = true;
    this.updateAstreinte();
  }

  // Méthode pour vérifier les doublons en excluant l'astreinte actuelle (avec code du planning)
checkDuplicateDateTimeForUpdate(newAstreinte: any, currentAstreinteId: any): any | null {
  if (!this.astreintes || this.astreintes.length === 0) return null;

  const newDebut = new Date(newAstreinte.DateHeureDebut);
  const newFin = new Date(newAstreinte.DateHeureFin);
  const newPriorite = newAstreinte.Priorite;

  for (const existingAstreinte of this.astreintes) {
    // Exclure l'astreinte actuelle
    if (existingAstreinte.code_interne === currentAstreinteId) {
      continue;
    }

    if (existingAstreinte.Priorite === newPriorite) {
      const existDebut = new Date(existingAstreinte.DateHeureDebut);
      const existFin = new Date(existingAstreinte.DateHeureFin);

      // Vérifier exactement les mêmes dates/heures
      const sameDateTime = (newDebut.getTime() === existDebut.getTime() && 
                           newFin.getTime() === existFin.getTime());

      if (sameDateTime && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
        return existingAstreinte; // Retourne l'astreinte conflictuelle avec son code
      }
    }
  }
  return null;
}

  // Méthode pour vérifier les chevauchements en excluant l'astreinte actuelle
checkPlanningOverlapsForUpdate(newAstreinte: any, currentAstreinteId: any): { hasOverlap: boolean, conflictingCode: string } {
  if (!this.astreintes || this.astreintes.length === 0) {
    return { hasOverlap: false, conflictingCode: '' };
  }

  const newDebut = new Date(newAstreinte.DateHeureDebut);
  const newFin = new Date(newAstreinte.DateHeureFin);
  const newDebutTr2 = newAstreinte.DateHeureDebutTr2 ? new Date(newAstreinte.DateHeureDebutTr2) : null;
  const newFinTr2 = newAstreinte.DateHeureFinTr2 ? new Date(newAstreinte.DateHeureFinTr2) : null;
  const newPriorite = newAstreinte.Priorite;
  const newTypeHoraire = newAstreinte.TypeHOHNO;
  const newTypeSegment = newAstreinte.TypeSegment;

  for (const existingAstreinte of this.astreintes) {
    // Exclure l'astreinte actuelle en cours de modification
    if (existingAstreinte.code_interne === currentAstreinteId) {
      continue;
    }

    // Vérifier si même priorité
    if (existingAstreinte.Priorite === newPriorite) {
      const existDebut = new Date(existingAstreinte.DateHeureDebut);
      const existFin = new Date(existingAstreinte.DateHeureFin);
      const existDebutTr2 = existingAstreinte.DateHeureDebutTr2 ? new Date(existingAstreinte.DateHeureDebutTr2) : null;
      const existFinTr2 = existingAstreinte.DateHeureFinTr2 ? new Date(existingAstreinte.DateHeureFinTr2) : null;
      const existTypeHoraire = existingAstreinte.TypeHOHNO;
      const existTypeSegment = existingAstreinte.TypeSegment;

      // Vérifier si les types de segmentation sont les mêmes
      const typesSegmentIdentiques = newTypeSegment === existTypeSegment;

      if (typesSegmentIdentiques) {
        // Vérifier si les types horaires sont les mêmes
        const typesHoraireIdentiques = newTypeHoraire === existTypeHoraire;

        // Pour les périodes non continues (TypeSegment = 0), on vérifie les chevauchements d'heures
        if (newTypeSegment === 0 && existTypeSegment === 0) {
          // Même date mais heures différentes → autorisé
          const sameDate = this.isSameDate(newDebut, existDebut) && this.isSameDate(newFin, existFin);
          
          if (sameDate) {
            // Vérifier si les heures se chevauchent
            if (this.isTimeOverlapping(newDebut, newFin, existDebut, existFin)) {
              // Vérifier s'il y a chevauchement des critères
              if (typesHoraireIdentiques && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
                return { 
                  hasOverlap: true, 
                  conflictingCode: existingAstreinte.code_interne || existingAstreinte.Astreinte || 'N/A' 
                };
              }
            }
            
            // Vérifier les tranches 2 si elles existent
            if (newDebutTr2 && newFinTr2 && existDebutTr2 && existFinTr2 &&
                this.isTimeOverlapping(newDebutTr2, newFinTr2, existDebutTr2, existFinTr2)) {
              // Vérifier s'il y a chevauchement des critères
              if (typesHoraireIdentiques && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
                return { 
                  hasOverlap: true, 
                  conflictingCode: existingAstreinte.code_interne || existingAstreinte.Astreinte || 'N/A' 
                };
              }
            }
          }
        } else {
          // Pour les périodes continues ou mixtes, vérifier normalement
          // Vérifier chevauchement tranche 1
          if (this.isOverlapping(newDebut, newFin, existDebut, existFin)) {
            // Si chevauchement ET types horaires identiques ET chevauchement de critères → détecter le conflit
            if (typesHoraireIdentiques && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
              return { 
                hasOverlap: true, 
                conflictingCode: existingAstreinte.code_interne || existingAstreinte.Astreinte || 'N/A' 
              };
            }
          }

          // Vérifier chevauchement tranche 2 si elle existe
          if (newDebutTr2 && newFinTr2 && existDebutTr2 && existFinTr2 &&
            this.isOverlapping(newDebutTr2, newFinTr2, existDebutTr2, existFinTr2)) {
            // Si chevauchement ET types horaires identiques ET chevauchement de critères → détecter le conflit
            if (typesHoraireIdentiques && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
              return { 
                hasOverlap: true, 
                conflictingCode: existingAstreinte.code_interne || existingAstreinte.Astreinte || 'N/A' 
              };
            }
          }

          // Vérifier chevauchements croisés entre tranches
          if (newDebutTr2 && newFinTr2 && this.isOverlapping(newDebutTr2, newFinTr2, existDebut, existFin)) {
            // Si chevauchement ET types horaires identiques ET chevauchement de critères → détecter le conflit
            if (typesHoraireIdentiques && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
              return { 
                hasOverlap: true, 
                conflictingCode: existingAstreinte.code_interne || existingAstreinte.Astreinte || 'N/A' 
              };
            }
          }

          if (existDebutTr2 && existFinTr2 && this.isOverlapping(newDebut, newFin, existDebutTr2, existFinTr2)) {
            // Si chevauchement ET types horaires identiques ET chevauchement de critères → détecter le conflit
            if (typesHoraireIdentiques && this.areCriteresIdentiques(newAstreinte, existingAstreinte)) {
              return { 
                hasOverlap: true, 
                conflictingCode: existingAstreinte.code_interne || existingAstreinte.Astreinte || 'N/A' 
              };
            }
          }
        }
      }
    }
  }

  return { hasOverlap: false, conflictingCode: '' };
}
// Méthode pour vérifier les doublons en excluant l'astreinte actuelle
checkDuplicateDateTimeAndPriorityForUpdate(newAstreinte: any, currentAstreinteId: any): boolean {
  if (!this.astreintes || this.astreintes.length === 0) return false;

  const newDebut = new Date(newAstreinte.DateHeureDebut).getTime();
  const newFin = new Date(newAstreinte.DateHeureFin).getTime();
  const newPriorite = newAstreinte.Priorite;

  return this.astreintes.some((existingAstreinte: any) => {
    // Exclure l'astreinte actuelle
    if (existingAstreinte.code_interne === currentAstreinteId) {
      return false;
    }

    if (existingAstreinte.Priorite === newPriorite) {
      const existDebut = new Date(existingAstreinte.DateHeureDebut).getTime();
      const existFin = new Date(existingAstreinte.DateHeureFin).getTime();

      // Vérifier exactement les mêmes dates/heures
      return (newDebut === existDebut && newFin === existFin);
    }
    return false;
  });
}
  // Ajoutez cette méthode pour mettre à jour l'astreinte
  updateAstreinte() {
    if (!this.selectedAstreintePrincipale?.code_interne ||
      !this.astreinte.DateHeureDebut ||
      !this.astreinte.DateHeureFin) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Veuillez remplir tous les champs obligatoires',
        life: 3000
      });
      this.isDisable = false;
      return;
    }


   const payload: any = {
    code_DO: this.do,
    code_interne: this.astreinte.code_interne,
    code_Page: this.astreinte.code_Page?.code_interne || null,
    Astreinte: this.selectedAstreintePrincipale.code_interne,
    DateHeureDebut: this.formatDateForApi(this.astreinte.DateHeureDebut),
    DateHeureFin: this.formatDateForApi(this.astreinte.DateHeureFin),
    // on met à jour selon le contenu réel de timeRanges[1]
    DateHeureDebutTr2: this.timeRanges[1]?.start
      ? this.formatDateForApi(this.concatDateTime(this.astreinte.DateHeureDebut, this.timeRanges[1].start))
      : null,
    DateHeureFinTr2: this.timeRanges[1]?.end
      ? this.formatDateForApi(this.concatDateTime(this.astreinte.DateHeureFin, this.timeRanges[1].end))
      : null,
    TypeSegment: this.astreinte.segmentationType,
    Priorite: this.prioriteValue,
    Commentaire: this.astreinte.Commentaire,
    TypeHOHNO: this.astreinte.TypeHOHNO,
    Critere1: null, Critere2: null, Critere3: null, Critere4: null, Critere5: null,
    Critere6: null, Critere7: null, Critere8: null, Critere9: null, Critere10: null,
    Escalade1: null, Escalade2: null, Escalade3: null, Escalade4: null, Escalade5: null,
    Escalade6: null, Escalade7: null, Escalade8: null, Escalade9: null, Escalade10: null,
    Escalade11: null, Escalade12: null, Escalade13: null, Escalade14: null, Escalade15: null
  };

    // Remplir les escalades
    this.getEscaladeLevels().forEach(level => {
      const escalade = this.selectedEscalades[level];
      if (escalade?.astreinte) {
        payload[`Escalade${level}`] = escalade.astreinte.code_interne;
      }
    });

   // Gestion selon le type de segmentation
    if (this.showSegmentRange) {
      // Période continue
      payload.DateHeureDebut = this.formatDateForApi(this.astreinte.DateHeureDebut);
      payload.DateHeureFin = this.formatDateForApi(this.astreinte.DateHeureFin);
    } else {
      // Période non continue
      // tranche 1 obligatoire
      const firstRange = this.timeRanges[0];
      if (this.dateDebut && this.dateFin && firstRange.start && firstRange.end) {
        payload.DateHeureDebut = this.formatDateForApi(this.concatDateTime(this.dateDebut, firstRange.start));
        payload.DateHeureFin = this.formatDateForApi(this.concatDateTime(this.dateFin, firstRange.end));
      }

      // Si une deuxième tranche est remplie
      if (this.timeRanges.length > 1 && this.timeRanges[1].start && this.timeRanges[1].end && this.dateDebut && this.dateFin) {
        payload.DateHeureDebutTr2 = this.formatDateForApi(this.concatDateTime(this.dateDebut, this.timeRanges[1].start));
        payload.DateHeureFinTr2 = this.formatDateForApi(this.concatDateTime(this.dateFin, this.timeRanges[1].end));
      }
    }

  // Remplir les valeurs des critères existants
  this.criteres.forEach(critere => {
    const critereKey = `Critere${critere.Critere}`;
    payload[critereKey] = this.critereValues[critere.Critere] || null;
  });

  console.log('Payload update Astreinte envoyé:', payload);

    this.astreinteService.updateAstreinte(payload).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Succès',
          detail: 'Astreinte modifiée avec succès',
          life: 3000
        });
        this.isDisable = false;
        this.hideEditDialog();
        this.loadAstreinteData();
      },
      error: (error) => {
        console.error('Erreur:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Échec de la modification de l\'astreinte',
          life: 3000
        });
      }
    });
  }

   private convertToDate(dateString: any): Date | null {
    if (!dateString) return null;
    
    // Si c'est déjà un objet Date
    if (dateString instanceof Date) return dateString;
    
    // Si c'est une string au format ISO (2025-09-03 21:00:00.000)
    if (typeof dateString === 'string') {
      // Remplace l'espace par 'T' pour le format ISO standard
      const isoString = dateString.replace(' ', 'T');
      return new Date(isoString);
    }
    
    return null;
  }


  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'customGlobal');
  }

  // Ajoute cette méthode pour éviter l'erreur TS2551 et logguer les timeRanges
  logTimeRanges() {
    console.clear();
    this.timeRanges.forEach((range, index) => {
      if (range.start && range.end) {
        const formatTime = (date: Date) => {
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          return `${hours}:${minutes}`;
        };
        console.log(`Tranche ${index + 1}:`);
        console.log(`Heure début: ${formatTime(range.start)}`);
        console.log(`Heure fin: ${formatTime(range.end)}`);
        console.log('---------------------');
      } else {
        console.log(`Tranche ${index + 1}: heures non définies`);
      }
    });
  }

  // Correction de setSegmentationType pour ne pas perdre les valeurs
  setSegmentationType(type: number) {
    this.astreinte.segmentationType = type;
    this.showSegmentRange = type === 1;

    if (type === 1) {
      // Garder les dates existantes sinon initialiser à null
      if (!this.astreinte.DateHeureDebut) this.astreinte.DateHeureDebut = null;
      if (!this.astreinte.DateHeureFin) this.astreinte.DateHeureFin = null;
      if (!this.timeRanges || this.timeRanges.length === 0) {
        this.timeRanges = [{ start: null, end: null }];
      }
    } else {
      // Même principe pour non continu
      if (!this.astreinte.DateHeureDebut) this.astreinte.DateHeureDebut = null;
      if (!this.astreinte.DateHeureFin) this.astreinte.DateHeureFin = null;
      if (!this.timeRanges || this.timeRanges.length === 0) {
        this.timeRanges = [{ start: null, end: null }];
      }
    }
  }

  // Garder addTimeRange et removeTimeRange avec le log
  addTimeRange() {
    if (this.timeRanges.length < 2) {
      this.timeRanges.push({ start: null, end: null });
      this.logTimeRanges(); // Log après ajout
    }
  }

  removeTimeRange() {
    if (this.timeRanges.length > 1) {
      this.timeRanges.pop();
      this.logTimeRanges(); // Log après suppression
    }
  }

  addCritere(index: number) {
    if (this.criteres.length < 2) {
      this.criteres.push({
        libelle: '',
        nomTable: null,
        colonne: null
      });
    }
  }


  // removeCritere(index: number) {
  //   const critere = this.criteres[index];

  //   if (!critere) return;

  //   // Critère pas encore enregistré → suppression locale seulement
  //   if (!critere.code_interne) {
  //     this.criteres.splice(index, 1);
  //     //this.updateCriteresAfterDeletion();
  //     return;
  //   }

  //   // Critère enregistré → suppression côté serveur
  //   this.astreinteService.deleteAstreinteCritere(critere.code_interne).subscribe({
  //     next: () => {
  //       console.log('Critère supprimé avec succès');
  //       this.criteres.splice(index, 1);
  //       //this.updateCriteresAfterDeletion(); // reindex tous les critères
  //       this.loadAstreinteCriteres();
  //     },
  //     error: (err) => {
  //       console.error('Erreur lors de la suppression du critère', err);
  //     }
  //   });
  // }
removeCritere(index: number) {
  this.confirmationService.confirm({
    message: 'Souhaitez-vous vraiment supprimer ce Critere ?',
    header: 'Confirmer',
    icon: 'pi pi-exclamation-triangle',
    rejectButtonStyleClass: 'p-button-secondary',
    acceptLabel: 'Oui',
    rejectLabel: 'Non',
    accept: () => {
      const critere = this.criteres[index];
      if (!critere) return;

      // Critère pas encore enregistré → suppression locale seulement
      if (!critere.code_interne) {
        this.criteres.splice(index, 1);
        return;
      }

      this.astreinteService.deleteAstreinteCritere(critere.code_interne).subscribe({
        next: () => {
          console.log('Critère supprimé avec succès');
          this.criteres.splice(index, 1);
          this.loadAstreinteCriteres();

          this.messageService.add({
            severity: 'success',
            summary: 'Succès',
            detail: 'Critère supprimé avec succès',
            life: 3000,
          });
        },
        error: (err: any) => {
          console.error('Erreur lors de la suppression du critère', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: 'Échec de la suppression du Critère',
            life: 3000
          });
        }
      });
    }
  });
}

  resetCriteres() {
    this.criteres = [];
  }

  saveCriteres() {
    console.log('Critères enregistrés :', this.criteres);
    // Ici tu peux faire un appel API
  }
  // Appelé quand une table est sélectionnée
  onTableChange(critere: any) {
    const tableName = critere.nomTable?.nom;
    if (tableName && this.colonnesDict[tableName]) {
      this.colonnesList = this.colonnesDict[tableName];
      critere.colonne = null; // reset colonne sélectionnée
    }
  }
  markModified(index: number) {
    this.criteres[index].modified = true;
  }

  saveOrUpdateCritere(index: number) {
    const critere = this.criteres[index];

    // Déterminer la valeur du champ Critere dynamiquement
    let critereValue: number;
    if (index === 0) {
      critereValue = 1; // Premier critère = 1 par défaut
    } else if (index === 1) {
      // Si le premier a 1 → mettre 2, sinon mettre 1
      const premierCritere = this.criteres[0];
      critereValue = premierCritere?.Critere === 1 ? 2 : 1;
    } else {
      // Pour les autres cas, tu peux ajuster selon ta logique métier
      critereValue = index + 1;
    }

    // Payload pour ajout
    const payloadAdd = {
      code_DO: this.do,
      Libelle: critere.Libelle,
      Critere: critereValue,
      NomChamp: critere.NomChamp,
      TableRecherche: critere.TableRecherche
    };

    // Payload pour modification
    const payloadModif = {
      code_interne: critere.code_interne,
      Libelle: critere.Libelle,
      Critere: critere.Critere,
      NomChamp: critere.NomChamp,
      TableRecherche: critere.TableRecherche
    };

    if (critere.code_interne) {
      // Modification
      this.astreinteService.updateAstreinteCritere(payloadModif).subscribe({
        next: (res: any) => {
          console.log('Critère modifié avec succès', res);
          this.criteres[index].modified = false;
          this.loadAstreinteCriteres();
          this.messageService.add({
            severity: 'success',
            summary: 'Succès',
            detail: 'Critère modifié avec succès',
            life: 3000,
          });
        },
        error: (err: any) => {
          console.error('Erreur lors de la modification', err);
          this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Échec de la modification de critere',
          life: 3000
        });
        }
      });
    } else {
      // Ajout
      this.astreinteService.addAstreinteCritere(payloadAdd).subscribe({
        next: (res: any) => {
          console.log('Critère ajouté avec succès', res);
          this.criteres[index].code_interne = res.code_interne; // récupérer ID de la BD
          this.criteres[index].Critere = critereValue; // on garde la valeur attribuée
          this.criteres[index].modified = false;
          this.loadAstreinteCriteres();
          this.messageService.add({
            severity: 'success',
            summary: 'Succès',
            detail: 'Critère ajouté avec succès',
            life: 3000,
          });
        },
        error: (err) => {
          console.error('Erreur lors de l’ajout', err);
          this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Échec de l\'ajout de critere',
          life: 3000
        });
        }
      });
    }
  }
  resetCritere(index: number) {
    // Recharge toute la liste depuis l’API → tout est remis à l’état serveur
    this.confirmationService.confirm({
    message: 'Souhaitez-vous vraiment réinitialiser toutes les données ?',
    header: 'Confirmer',
    icon: 'pi pi-exclamation-triangle',
    rejectButtonStyleClass: 'p-button-secondary',
    acceptLabel: 'Oui',
    rejectLabel: 'Non',
    accept: () => {
    this.loadAstreinteCriteres();
    }

  });
  }
isAddMode(critere: any): boolean {
  return !critere.code_interne;
}

isSaveEnabled(critere: any): boolean {
  // Cas ajout
  if (this.isAddMode(critere)) {
    return !!critere.Libelle && !!critere.TableRecherche && !!critere.NomChamp;
  }

  // Cas modification
  return critere.modified && !!critere.TableRecherche && !!critere.NomChamp;
}

}
